import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useIntroductionData } from "../../hooks/useIntroductionData";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEO from "@/components/SEO";
import RichContentRenderer from "../../components/base/RichContentRenderer";

const GreetingPage = () => {
  const { i18n } = useTranslation();
  const isKr = i18n.language === "kr";
  const { data, loading } = useIntroductionData("loi-chao");

  const title = isKr ? (data?.title_kr ?? "인사말") : (data?.title_vi ?? "Lời chào");
  const content = isKr ? (data?.content_kr ?? "") : (data?.content_vi ?? "");

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <SEO
        title={`${title} | KCANIA`}
        description={isKr ? "한국 탄소나노 산업협회 인사말" : "Lời chào từ Hiệp Hội Công Nghiệp Carbon Nano Hàn Quốc"}
        keywords={isKr ? "인사말, 협회, 한국" : "lời chào, hiệp hội, hàn quốc"}
      />
      <Navbar />
      <div className="max-w-[900px] mx-auto px-4 md:px-6 py-10 md:py-16">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-xs text-gray-400 mb-8">
          <Link to="/" className="hover:text-[#004A99] cursor-pointer">
            {isKr ? "홈" : "Trang chủ"}
          </Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-gray-500">{title}</span>
        </nav>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-10">
          <h1 className="text-2xl md:text-3xl font-black text-gray-800 mb-6 pb-4 border-b border-gray-100">
            {title}
          </h1>

          {loading ? (
            <div className="space-y-4 animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-3/4" />
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="h-4 bg-gray-200 rounded w-5/6" />
            </div>
          ) : (
            <RichContentRenderer content={content} />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GreetingPage;